var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9974 18.3327C14.5998 18.3327 18.3307 14.6017 18.3307 9.99935C18.3307 5.39698 14.5998 1.66602 9.9974 1.66602C5.39502 1.66602 1.66406 5.39698 1.66406 9.99935C1.66406 14.6017 5.39502 18.3327 9.9974 18.3327Z",
    stroke: "#A7B3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667V10",
    stroke: "#A7B3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.10742C9.90735 6.10742 9.81671 6.13492 9.73961 6.18644C9.66251 6.23795 9.60242 6.31117 9.56694 6.39684C9.53145 6.48251 9.52217 6.57677 9.54026 6.66771C9.55835 6.75866 9.603 6.84219 9.66857 6.90776C9.73413 6.97333 9.81767 7.01798 9.90861 7.03607C9.99956 7.05416 10.0938 7.04487 10.1795 7.00939C10.2652 6.97391 10.3384 6.91381 10.3899 6.83672C10.4414 6.75962 10.4689 6.66898 10.4689 6.57625C10.4691 6.51464 10.4571 6.4536 10.4336 6.39664C10.41 6.33969 10.3755 6.28794 10.332 6.24437C10.2884 6.2008 10.2366 6.16628 10.1797 6.14277C10.1227 6.11927 10.0617 6.10726 10.0001 6.10742Z",
    fill: "#A7B3C0",
    stroke: "#A7B3C0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.f22431edec34010d49e02dad9fb70790.svg";
export { ForwardRef as ReactComponent };